import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LayoutWrapper from '../components/LayoutWrapper';

const Home = () => {
  const { user, isAuthenticated } = useAuth();

  // Debug logging
  console.log('Home - User:', user);
  console.log('Home - User role:', user?.role);
  console.log('Home - Is authenticated:', isAuthenticated);

  if (isAuthenticated) {
    return (
      <LayoutWrapper>
        <div className="relative overflow-hidden -m-3 sm:-m-4 min-h-[calc(100vh-8rem)]">
          {/* Dotted background pattern */}
          <div
            className="absolute inset-0 opacity-50 z-0"
            style={{
              backgroundImage: 'radial-gradient(circle, rgba(239, 68, 68, 0.15) 3px, transparent 3px)',
              backgroundSize: '25px 25px'
            }}
          />

          {/* Main content */}
          <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-8rem)] animate-slide-up px-4 sm:px-6">
            <div className="text-center max-w-full">
              <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl xl:text-[12rem] font-bold text-red-600 mb-4 sm:mb-6 tracking-tight leading-none break-words">
                IMMERSION
              </h1>
              <p className="text-xs sm:text-sm md:text-base lg:text-xl xl:text-2xl text-gray-600 font-medium uppercase tracking-widest px-2">
                Management and Tracking
              </p>
              <div className="mt-6 sm:mt-8">
                <p className="text-sm sm:text-base lg:text-lg text-gray-500 break-words">
                  Bienvenue, {user?.name} !
                </p>
              </div>
            </div>
          </div>
        </div>
      </LayoutWrapper>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 relative overflow-hidden">
      {/* Dotted background pattern */}
      <div 
        className="absolute inset-0 opacity-50 z-0"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(239, 68, 68, 0.15) 3px, transparent 3px)',
          backgroundSize: '25px 25px'
        }}
      />
      
      {/* Header */}
      <header className="relative z-10 flex justify-end items-center p-6 animate-fade-in">
        <div className="flex items-center space-x-4">
          <Link 
            to="/login" 
            className="px-6 py-3 bg-red-600 text-white rounded-xl transition-all duration-200 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 active:scale-95 active:shadow-md active:translate-y-0"
          >
            
          Se connecter
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-120px)] animate-slide-up px-4 sm:px-6">
        <div className="text-center max-w-full">
          <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl xl:text-[12rem] font-bold text-immersion-red mb-4 sm:mb-6 tracking-tight leading-none break-words">
            IMMERSION
          </h1>
          <p className="text-xs sm:text-sm md:text-base lg:text-xl xl:text-2xl text-gray-600 font-medium uppercase tracking-widest px-2">
            Management and Tracking
          </p>
        </div>
      </div>

      
    </div>
  );
};

export default Home;
